import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getToken, limparToken } from "../utils/auth";

const API_URL =
  process.env.REACT_APP_API_URL || "https://app.nvplaydigital.com";

function getUsuarioDoToken() {
  try {
    const token = getToken();

    if (!token) return null;

    const partes = token.split(".");
    if (partes.length < 2) return null;

    const payload = JSON.parse(atob(partes[1]));

    return payload || null;
  } catch {
    return null;
  }
}

export default function MainLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuAberto, setMenuAberto] = useState(false);
  const [podeVerControleCreditos, setPodeVerControleCreditos] = useState(false);
  const [podeVerChat, setPodeVerChat] = useState(false);
  const [podeGerenciarChat, setPodeGerenciarChat] = useState(false);
  const [podeVerTopGestor, setPodeVerTopGestor] = useState(false);

  const usuarioLogado = getUsuarioDoToken();

  useEffect(() => {
    const token = getToken();

    if (!token) {
      limparToken();
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    async function verificarAcessoControleCreditos() {
      const token = getToken();

      if (!token) {
        setPodeVerControleCreditos(false);
        return;
      }

      try {
        const resposta = await fetch(`${API_URL}/api/creditos/acesso`, {
          headers: {
            Authorization: token,
          },
        });

        const data = await resposta.json().catch(() => ({}));

        setPodeVerControleCreditos(Boolean(data?.podeAcessar));
      } catch {
        setPodeVerControleCreditos(false);
      }
    }

    verificarAcessoControleCreditos();
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/chat-sdvision/acesso`, { headers: { Authorization: getToken() } })
      .then((r) => r.json())
      .then((d) => { setPodeVerChat(Boolean(d?.podeAcessar)); setPodeGerenciarChat(Boolean(d?.podeGerenciar)); })
      .catch(() => { setPodeVerChat(false); setPodeGerenciarChat(false); });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/top-gestor/acesso`, { headers: { Authorization: getToken() } })
      .then((r) => r.json())
      .then((d) => setPodeVerTopGestor(Boolean(d?.podeAcessar)))
      .catch(() => setPodeVerTopGestor(false));
  }, []);

  function sair() {
    limparToken();
    navigate("/login");
  }

  function ir(path) {
    setMenuAberto(false);
    navigate(path);
  }

  const ativo = (path) => location.pathname === path;

  return (
    <>
      <style>{css}</style>

      <div className="layout">
        {menuAberto && (
          <div className="overlay" onClick={() => setMenuAberto(false)}>
            <aside className="sidebar mobile" onClick={(e) => e.stopPropagation()}>
              <Menu
                ativo={ativo}
                ir={ir}
                sair={sair}
                usuario={usuarioLogado}
                podeVerControleCreditos={podeVerControleCreditos}
                podeVerChat={podeVerChat}
                podeGerenciarChat={podeGerenciarChat}
                podeVerTopGestor={podeVerTopGestor}
              />
            </aside>
          </div>
        )}

        <aside className="sidebar desktop">
          <Menu
            ativo={ativo}
            ir={ir}
            sair={sair}
            usuario={usuarioLogado}
            podeVerControleCreditos={podeVerControleCreditos}
            podeVerChat={podeVerChat}
            podeGerenciarChat={podeGerenciarChat}
            podeVerTopGestor={podeVerTopGestor}
          />
        </aside>

        <div className="content">
          <header className="topbar">
            <button className="menuBtn" onClick={() => setMenuAberto(true)}>
              ☰
            </button>

            <button className="voltarBtn" onClick={() => navigate(-1)}>
              ← Voltar
            </button>

            <strong>Gestor One</strong>
          </header>

          <main className="main">{children}</main>
        </div>
      </div>
    </>
  );
}

function Menu({ ativo, ir, sair, podeVerControleCreditos, podeVerChat, podeGerenciarChat, podeVerTopGestor }) {
  return (
    <>
      <div className="brand">
        <img src="/gestor-one-64.png" alt="" className="brandIcon" />
        <h2 className="logo">Gestor One</h2>
      </div>

      <button className={ativo("/dashboard") ? "nav active" : "nav"} onClick={() => ir("/dashboard")}>
        Dashboard
      </button>

      <button className={ativo("/lancamentos") ? "nav active" : "nav"} onClick={() => ir("/lancamentos")}>
        Relatório Diário
      </button>

      <button className={ativo("/relatorios") ? "nav active" : "nav"} onClick={() => ir("/relatorios")}>
        Fechamento Semanal
      </button>

      <button className={ativo("/financeiro-pessoal") ? "nav active" : "nav"} onClick={() => ir("/financeiro-pessoal")}>
        💼 Financeiro Pessoal
      </button>

      <button className={ativo("/ranking") ? "nav active" : "nav"} onClick={() => ir("/ranking")}>
        Ranking
      </button>

      <div className="separator" />

      <button className={ativo("/usuarios") ? "nav active" : "nav"} onClick={() => ir("/usuarios")}>
        Usuários
      </button>

      <button className={ativo("/minha-rede") ? "nav active" : "nav"} onClick={() => ir("/minha-rede")}>
        Minha rede
      </button>

      {podeVerControleCreditos && (
        <button
          className={ativo("/controle-creditos") ? "nav active" : "nav"}
          onClick={() => ir("/controle-creditos")}
        >
          📦 Controle de Créditos
        </button>
      )}

      {podeVerChat && (
        <button className={ativo("/chat") ? "nav active" : "nav"} onClick={() => ir("/chat")}>💬 Chat SD Vision</button>
      )}
      {podeGerenciarChat && (
        <button className={ativo("/chat-sdvision") ? "nav active" : "nav"} onClick={() => ir("/chat-sdvision")}>📋 Solicitações SD Vision</button>
      )}

      {podeVerTopGestor && (
        <button className={ativo("/top-gestor") ? "nav active" : "nav"} onClick={() => ir("/top-gestor")}>✨ Top Gestor <small className="betaMenu">beta</small></button>
      )}

      <button className={ativo("/perfil") ? "nav active" : "nav"} onClick={() => ir("/perfil")}>
        Meu perfil
      </button>

      <button className="sairBtn" onClick={sair}>
        Sair
      </button>
    </>
  );
}

const css = `
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  overflow-x: hidden;
}

.layout {
  display: flex;
  min-height: 100vh;
  background: #f1f5f9;
}

.sidebar {
  width: 240px;
  background: #0f172a;
  color: white;
  padding: 20px;
  flex-shrink: 0;
}

.logo {
  margin: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 24px;
}

.brandIcon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
}

.nav {
  display: block;
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  color: white;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  margin-bottom: 6px;
  font-size: 15px;
}

.nav.active {
  background: #1e293b;
}

.betaMenu { color: #78e7ff; text-transform: uppercase; font-size: 10px; }

.separator {
  height: 1px;
  background: #334155;
  margin: 16px 0;
}

.sairBtn {
  width: 100%;
  margin-top: 20px;
  padding: 12px;
  border-radius: 10px;
  border: none;
  background: #dc2626;
  color: white;
  cursor: pointer;
  font-weight: bold;
}

.content {
  flex: 1;
  min-width: 0;
}

.topbar {
  background: white;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 20;
}

.menuBtn {
  display: none;
  padding: 10px 14px;
  border-radius: 10px;
  border: none;
  background: #0f172a;
  color: white;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

.voltarBtn {
  padding: 10px 14px;
  border-radius: 10px;
  border: none;
  background: #e5e7eb;
  cursor: pointer;
  font-weight: bold;
}

.main {
  padding: clamp(14px, 3vw, 28px);
  overflow-x: hidden;
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 9999;
}

.mobile {
  height: 100%;
  width: 260px;
}

@media (max-width: 768px) {
  .desktop {
    display: none;
  }

  .menuBtn {
    display: block;
  }

  .topbar {
    font-size: 14px;
  }

  .voltarBtn {
    padding: 9px 12px;
  }

  .main {
    padding: 14px;
  }
}
`;
